<template>
    <div class="content-wrapper">
        <app-page-top-section :title="''">
            <app-default-button
                class="mb-4"
                :title="$fieldTitle('add', 'tag', true)"
                v-if="$can('create_interview_tag')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="interview-tag-table"
            :options="options"
            @action="triggerActions"
        />

        <app-interview-tag-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            :accept-types="[4]"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('interview-tag-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import InterviewTagMixins from "../../../Mixins/InterviewTagMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AttendanceTagSettings",
    mixins: [HelperMixin, InterviewTagMixins],
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    created() {
        // Override the options to filter by attendance tags only (type=4)
        this.options.url = `${TENANT_BASE_URL}app/interview-tag?type=4`;
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/interview-tag/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>
